import "aos/dist/aos.css";
import PaymentDetailsTable from "../Dashboards/PaymentDetailsTable";

const PaymentDetails = () => {
    return (
        <div className="mt-6">
            <PaymentDetailsTable />
        </div>
    );
};

export default PaymentDetails;
